export default __webpack_public_path__ + "static/media/natalia.c1a2c017.png";